import { navigateInShell } from '../../shell/navigation/rootNavigation';

type NavigationLike = {
  navigate: (route: string, params?: object) => void;
};

/** Abre Configurar agendas (crear / editar agendas). */
export function openAppointmentResources(navigation: NavigationLike): void {
  navigateInShell(navigation, 'AppointmentResources');
}
